import React, { useEffect, useState } from "react";
import AddProperty from "../../components/PropertyView/AddProperty";
import PropertyDetailsAdd from "../../components/PropertyView/PropertyDetailsAdd";
import PropertyRoomsAdd from "../../components/PropertyView/PropertyRoomsAdd";
import { useLocation } from "react-router-dom";

const PropertyAdd = () => {
  const location = useLocation();
  const [tabs, setTabs] = useState(1);
  const [valueType, setValueType] = useState(1);
  const [property_id, setProperty_id] = useState('')

  const [owner_id, setOwner_id] = useState()

  console.log('owner_id', owner_id)



  return (
    <div className="dashRightView home_section">
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
          Property Add
        </h2>
      </div>
      <div className="d-flex gap-4 mt-3">
        <h2
          onClick={() => {
            setTabs(1);
          }}
          className={`${tabs == 1 ? "active_tabs" : ""
            } f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}
        >
          Property
        </h2>
        <h2
          onClick={() => {
            setTabs(2);
          }}
          className={`${tabs == 2 ? "active_tabs" : ""
            } f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}
        >
          Details
        </h2>
        {valueType == 2 && (
          <h2
            onClick={() => {
              setTabs(3);
            }}
            className={`${tabs == 3 ? "active_tabs" : ""
              } f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}
          >
            Rooms
          </h2>
        )}
      </div>

      {tabs == 1 && (
        <AddProperty
          setProperty_id={setProperty_id}
          setValueType={setValueType}
          valueType={valueType}
          setTabs={setTabs}
          setOwner_id={setOwner_id}
        />
      )}
      {tabs == 2 && (
        <PropertyDetailsAdd
          property_id={property_id}
          setValueType={setValueType}
          valueType={valueType}
          setTabs={setTabs}
          owner_id={owner_id}
        />
      )}
      {tabs == 3 && <PropertyRoomsAdd
        setTabs={setTabs}
        property_id={property_id}
        owner_id={owner_id}

      />}
    </div>
  );
};

export default PropertyAdd;
